var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"nav-lf"},[_c('MusicType',{style:({ paddingLeft: _vm.num + 'px' }),attrs:{"width":100,"type":_vm.type,"tabsList":_vm.tabsList,"dropdownList":_vm.dropdownList}})],1),_c('div',{staticClass:"main-box"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }